import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, Check, ChevronDown } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'KIT DI BENVENUTO BALLET PRONTO™',
  image: 'https://images.unsplash.com/photo-1519682337058-a94d519337bc?auto=format&fit=crop&w=1200&h=400&q=80',
  slides: ["Tutto ciò che serve per iniziare a usare il sistema lo stesso giorno dell'acquisto.", 'Guida di avvio rapido in 3 passi e checklist completa di preparazione della sala.', 'Protocollo della prima lezione con allieve nuove.']
}, {
  num: 2,
  title: 'GUIDA ANTI-ABBANDONO™',
  image: 'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?auto=format&fit=crop&w=1200&h=400&q=80',
  slides: ['Il sistema psicologico per fare in modo che le tue allieve non vogliano mai smettere di ballare.', 'Le 7 ragioni per cui le allieve abbandonano e come prevenirle.', 'Tecniche di motivazione specifiche per ballet adulto.', 'Scripts di conversazione per riconnettersi con allieve demotivate.']
}, {
  num: 3,
  title: 'PLANNER 21 GIORNI DI TECNICA™',
  image: 'https://images.unsplash.com/photo-1547153760-18fc86324498?auto=format&fit=crop&w=1200&h=400&q=80',
  slides: ["Il sistema visivo per costruire l'abitudine del ballet nelle tue allieve in 3 settimane.", 'Planner giornaliero pronto da consegnare.', 'Esercizi da 10-15 minuti da praticare a casa.', 'Sistema di monitoraggio visivo con checkbox e progressi.']
}, {
  num: 4,
  title: 'GLOSSARIO UFFICIALE BALLET ITALIANO™',
  image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=1200&h=400&q=80',
  slides: ['120+ termini ufficiali francese-italiano per insegnare con autorità e precisione.', 'Organizzato per categoria: posizioni, passi, salti, giri ed espressione.', 'Versione stampabile da tenere in sala durante le lezioni.']
}, {
  num: 5,
  title: 'RITUALE DI CHIUSURA DELLA LEZIONE™',
  image: 'https://images.unsplash.com/photo-1504609773096-104ff2c73ba4?auto=format&fit=crop&w=1200&h=400&q=80',
  slides: ['La routine di 7 minuti per terminare ogni lezione e fare in modo che le allieve vogliano tornare.', 'Protocollo completo di cool-down fisico e chiusura emotiva.', 'Il finale della lezione determina se le allieve tornano la settimana successiva.']
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 bg-charcoal text-white relative overflow-hidden" data-id="element-13">
      <div className="absolute top-0 right-0 w-64 h-64 md:w-96 md:h-96 bg-ballet-900/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-14"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 md:w-96 md:h-96 bg-ballet-900/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-15"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-16">
        <div className="text-center mb-12 md:mb-16" data-id="element-17">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-ballet-500/20 mb-4 md:mb-6" data-id="element-18">
            <Gift className="w-6 h-6 md:w-8 md:h-8 text-ballet-300" data-id="element-19" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-3 md:mb-4" data-id="element-20">
            INCLUSI GRATIS
          </h2>
          <p className="text-xl md:text-2xl text-ballet-300 font-medium mb-2 md:mb-4" data-id="element-21">
            5 Bonus Strategici
          </p>
          <p className="text-sm md:text-base text-gray-400" data-id="element-22">
            Senza costo aggiuntivo — inclusi nell'offerta
          </p>
        </div>

        <div className="space-y-6 md:space-y-8 mb-10 md:mb-12" data-id="element-23">
          {bonuses.map((bonus, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4
          }} className="bg-white/5 border border-white/10 rounded-2xl md:rounded-3xl overflow-hidden backdrop-blur-sm" data-id="element-24">
                {/* 3:1 representative banner - Clickable Accordion Header */}
                <button onClick={() => toggleAccordion(index)} aria-expanded={isOpen} className="w-full relative aspect-[2.5/1] md:aspect-[3/1] overflow-hidden group text-left block" data-id="element-25">
                  <img src={bonus.image} alt={bonus.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-26" />
                  <div className="absolute inset-0 bg-gradient-to-r from-charcoal/95 via-charcoal/70 to-charcoal/30 transition-opacity duration-300 group-hover:opacity-90" data-id="element-27" />

                  <div className="relative h-full flex flex-col justify-center px-5 md:px-10" data-id="element-28">
                    <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-3" data-id="element-29">
                      <span className="inline-flex items-center bg-ballet-500 text-white text-[10px] md:text-xs font-bold tracking-widest px-2.5 py-1 md:px-3 rounded-full" data-id="element-30">
                        BONUS {bonus.num}
                      </span>
                      <span className="bg-white/20 text-white text-[10px] md:text-xs font-bold px-2 py-1 rounded uppercase" data-id="element-31">
                        Gratuito
                      </span>
                    </div>
                    <h3 className="text-lg md:text-3xl font-serif font-bold text-white leading-tight max-w-[85%] md:max-w-lg" data-id="element-32">
                      {bonus.title}
                    </h3>
                  </div>

                  <div className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20 transition-colors group-hover:bg-white/20" data-id="element-33">
                    <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 text-white transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-34" />
                  </div>
                </button>

                {/* description list - Accordion Content */}
                <AnimatePresence initial={false} data-id="element-35">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-36">
                      <div className="p-5 md:p-8 border-t border-white/10" data-id="element-37">
                        <ul className="space-y-3 md:space-y-4" data-id="element-38">
                          {bonus.slides.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-39">
                              <span className="mt-0.5 flex-shrink-0 w-4 h-4 md:w-5 md:h-5 rounded-full bg-ballet-500/20 flex items-center justify-center" data-id="element-40">
                                <Check className="w-2.5 h-2.5 md:w-3.5 md:h-3.5 text-ballet-300" data-id="element-41" />
                              </span>
                              <span className="text-sm md:text-base text-gray-200 leading-relaxed" data-id="element-42">
                                {point}
                              </span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <div className="text-center bg-ballet-900/40 border border-ballet-800/50 p-4 md:p-6 rounded-xl" data-id="element-43">
          <p className="text-lg md:text-xl font-bold text-ballet-200" data-id="element-44">
            VALORE TOTALE DEI BONUS: €197 — COMPLETAMENTE GRATUITI
          </p>
        </div>
      </div>
    </section>;
}